import React from 'react';
import { Modal, } from 'semantic-ui-react';

const Confirm = ({  open, onConfirm, onCancel }) => {
  
  return (
   
      <Modal size="mini" 
      open={open} 
      //onClose={onCancel}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      >
       
        <Modal.Content className='border'>
        <div> <h6>Do You Want To Delete ?</h6></div>
          <div className= 'display-center'>
          
          <span
            className="btntask" style={{background:'#cc3333'}}
              onClick={onConfirm}

          >
            Delete
          </span>
          <span
            className="btntask" 
              onClick={onCancel}

          >
            Cancel
          </span>
          </div>
        </Modal.Content>
      </Modal>
    
  );
}



export default Confirm;
